import { n as e, t } from "./apiUrls-H7pc1Czy.js";
import * as n from "zod";
//#region src/generated/core/bodySerializer.gen.ts
var r = { bodySerializer: (e) => JSON.stringify(e, (e, t) => typeof t == "bigint" ? t.toString() : t) };
Object.entries({
	$body_: "body",
	$headers_: "headers",
	$path_: "path",
	$query_: "query"
});
//#endregion
//#region src/generated/core/serverSentEvents.gen.ts
var i = ({ onRequest: e, onSseError: t, onSseEvent: n, responseTransformer: r, responseValidator: i, sseDefaultRetryDelay: a, sseMaxRetryAttempts: o, sseMaxRetryDelay: s, sseSleepFn: c, url: l, ...u }) => {
	let d, f = c ?? ((e) => new Promise((t) => setTimeout(t, e)));
	return { stream: async function* () {
		let c = a ?? 3e3, p = 0, m = u.signal ?? new AbortController().signal;
		for (; !m.aborted;) {
			p++;
			let a = u.headers instanceof Headers ? u.headers : new Headers(u.headers);
			d !== void 0 && a.set("Last-Event-ID", d);
			try {
				let t = {
					redirect: "follow",
					...u,
					body: u.serializedBody,
					headers: a,
					signal: m
				}, o = new Request(l, t);
				e && (o = await e(l, t));
				let s = await (u.fetch ?? globalThis.fetch)(o);
				if (!s.ok) throw Error(`SSE failed: ${s.status} ${s.statusText}`);
				if (!s.body) throw Error("No body in SSE response");
				let f = s.body.pipeThrough(new TextDecoderStream()).getReader(), p = "", h = () => {
					try {
						f.cancel();
					} catch {}
				};
				m.addEventListener("abort", h);
				try {
					for (;;) {
						let { done: e, value: t } = await f.read();
						if (e) break;
						p += t, p = p.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
						let a = p.split("\n\n");
						p = a.pop() ?? "";
						for (let e of a) {
							let t = e.split("\n"), a = [], o;
							for (let e of t) if (e.startsWith("data:")) a.push(e.replace(/^data:\s*/, ""));
							else if (e.startsWith("event:")) o = e.replace(/^event:\s*/, "");
							else if (e.startsWith("id:")) d = e.replace(/^id:\s*/, "");
							else if (e.startsWith("retry:")) {
								let t = Number.parseInt(e.replace(/^retry:\s*/, ""), 10);
								Number.isNaN(t) || (c = t);
							}
							let s, l = !1;
							if (a.length) {
								let e = a.join("\n");
								try {
									s = JSON.parse(e), l = !0;
								} catch {
									s = e;
								}
							}
							l && (i && await i(s), r && (s = await r(s))), n?.({
								data: s,
								event: o,
								id: d,
								retry: c
							}), a.length && (yield s);
						}
					}
				} finally {
					m.removeEventListener("abort", h), f.releaseLock();
				}
				break;
			} catch (e) {
				if (t?.(e), o !== void 0 && p >= o) break;
				let n = Math.min(c * 2 ** (p - 1), s ?? 3e4);
				await f(n);
			}
		}
	}() };
}, a = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, o = (e) => {
	switch (e) {
		case "form": return ",";
		case "pipeDelimited": return "|";
		case "spaceDelimited": return "%20";
		default: return ",";
	}
}, s = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, c = ({ allowReserved: e, explode: t, name: n, style: r, value: i }) => {
	if (!t) {
		let t = (e ? i : i.map((e) => encodeURIComponent(e))).join(o(r));
		switch (r) {
			case "label": return `.${t}`;
			case "matrix": return `;${n}=${t}`;
			case "simple": return t;
			default: return `${n}=${t}`;
		}
	}
	let s = a(r), c = i.map((t) => r === "label" || r === "simple" ? e ? t : encodeURIComponent(t) : l({
		allowReserved: e,
		name: n,
		value: t
	})).join(s);
	return r === "label" || r === "matrix" ? s + c : c;
}, l = ({ allowReserved: e, name: t, value: n }) => {
	if (n == null) return "";
	if (typeof n == "object") throw Error("Deeply-nested arrays/objects aren’t supported. Provide your own `querySerializer()` to handle these.");
	return `${t}=${e ? n : encodeURIComponent(n)}`;
}, u = ({ allowReserved: e, explode: t, name: n, style: r, value: i, valueOnly: a }) => {
	if (i instanceof Date) return a ? i.toISOString() : `${n}=${i.toISOString()}`;
	if (r !== "deepObject" && !t) {
		let t = [];
		Object.entries(i).forEach(([n, r]) => {
			t = [
				...t,
				n,
				e ? r : encodeURIComponent(r)
			];
		});
		let a = t.join(",");
		switch (r) {
			case "form": return `${n}=${a}`;
			case "label": return `.${a}`;
			case "matrix": return `;${n}=${a}`;
			default: return a;
		}
	}
	let o = s(r), c = Object.entries(i).map(([t, i]) => l({
		allowReserved: e,
		name: r === "deepObject" ? `${n}[${t}]` : t,
		value: i
	})).join(o);
	return r === "label" || r === "matrix" ? o + c : c;
}, d = /\{[^{}]+\}/g, f = ({ path: e, url: t }) => {
	let n = t, r = t.match(d);
	if (r) for (let t of r) {
		let r = !1, i = t.substring(1, t.length - 1), a = "simple";
		i.endsWith("*") && (r = !0, i = i.substring(0, i.length - 1)), i.startsWith(".") ? (i = i.substring(1), a = "label") : i.startsWith(";") && (i = i.substring(1), a = "matrix");
		let o = e[i];
		if (o == null) continue;
		if (Array.isArray(o)) {
			n = n.replace(t, c({
				explode: r,
				name: i,
				style: a,
				value: o
			}));
			continue;
		}
		if (typeof o == "object") {
			n = n.replace(t, u({
				explode: r,
				name: i,
				style: a,
				value: o,
				valueOnly: !0
			}));
			continue;
		}
		if (a === "matrix") {
			n = n.replace(t, `;${l({
				name: i,
				value: o
			})}`);
			continue;
		}
		let s = encodeURIComponent(a === "label" ? `.${o}` : o);
		n = n.replace(t, s);
	}
	return n;
}, p = ({ baseUrl: e, path: t, query: n, querySerializer: r, url: i }) => {
	let a = i.startsWith("/") ? i : `/${i}`, o = (e ?? "") + a;
	t && (o = f({
		path: t,
		url: o
	}));
	let s = n ? r(n) : "";
	return s.startsWith("?") && (s = s.substring(1)), s && (o += `?${s}`), o;
};
function m(e) {
	let t = e.body !== void 0;
	if (t && e.bodySerializer) return "serializedBody" in e ? e.serializedBody !== void 0 && e.serializedBody !== "" ? e.serializedBody : null : e.body === "" ? null : e.body;
	if (t) return e.body;
}
//#endregion
//#region src/generated/core/auth.gen.ts
var h = async (e, t) => {
	let n = typeof t == "function" ? await t(e) : t;
	if (n) return e.scheme === "bearer" ? `Bearer ${n}` : e.scheme === "basic" ? `Basic ${btoa(n)}` : n;
}, g = ({ parameters: e = {}, ...t } = {}) => (n) => {
	let r = [];
	if (n && typeof n == "object") for (let i in n) {
		let a = n[i];
		if (a == null) continue;
		let o = e[i] || t;
		if (Array.isArray(a)) {
			let e = c({
				allowReserved: o.allowReserved,
				explode: !0,
				name: i,
				style: "form",
				value: a,
				...o.array
			});
			e && r.push(e);
		} else if (typeof a == "object") {
			let e = u({
				allowReserved: o.allowReserved,
				explode: !0,
				name: i,
				style: "deepObject",
				value: a,
				...o.object
			});
			e && r.push(e);
		} else {
			let e = l({
				allowReserved: o.allowReserved,
				name: i,
				value: a
			});
			e && r.push(e);
		}
	}
	return r.join("&");
}, ee = (e) => {
	if (!e) return "stream";
	let t = e.split(";")[0]?.trim();
	if (t) {
		if (t.startsWith("application/json") || t.endsWith("+json")) return "json";
		if (t === "multipart/form-data") return "formData";
		if ([
			"application/",
			"audio/",
			"image/",
			"video/"
		].some((e) => t.startsWith(e))) return "blob";
		if (t.startsWith("text/")) return "text";
	}
}, te = (e, t) => t ? !!(e.headers.has(t) || e.query?.[t] || e.headers.get("Cookie")?.includes(`${t}=`)) : !1, ne = async ({ security: e, ...t }) => {
	for (let n of e) {
		if (te(t, n.name)) continue;
		let e = await h(n, t.auth);
		if (!e) continue;
		let r = n.name ?? "Authorization";
		switch (n.in) {
			case "query":
				t.query ||= {}, t.query[r] = e;
				break;
			case "cookie":
				t.headers.append("Cookie", `${r}=${e}`);
				break;
			default:
				t.headers.set(r, e);
				break;
		}
	}
}, _ = (e) => p({
	baseUrl: e.baseUrl,
	path: e.path,
	query: e.query,
	querySerializer: typeof e.querySerializer == "function" ? e.querySerializer : g(e.querySerializer),
	url: e.url
}), v = (e, t) => {
	let n = {
		...e,
		...t
	};
	return n.baseUrl?.endsWith("/") && (n.baseUrl = n.baseUrl.substring(0, n.baseUrl.length - 1)), n.headers = y(e.headers, t.headers), n;
}, re = (e) => {
	let t = [];
	return e.forEach((e, n) => {
		t.push([n, e]);
	}), t;
}, y = (...e) => {
	let t = new Headers();
	for (let n of e) {
		if (!n) continue;
		let e = n instanceof Headers ? re(n) : Object.entries(n);
		for (let [n, r] of e) if (r === null) t.delete(n);
		else if (Array.isArray(r)) for (let e of r) t.append(n, e);
		else r !== void 0 && t.set(n, typeof r == "object" ? JSON.stringify(r) : r);
	}
	return t;
}, b = class {
	fns = [];
	clear() {
		this.fns = [];
	}
	eject(e) {
		let t = this.getInterceptorIndex(e);
		this.fns[t] && (this.fns[t] = null);
	}
	exists(e) {
		let t = this.getInterceptorIndex(e);
		return !!this.fns[t];
	}
	getInterceptorIndex(e) {
		return typeof e == "number" ? this.fns[e] ? e : -1 : this.fns.indexOf(e);
	}
	update(e, t) {
		let n = this.getInterceptorIndex(e);
		return this.fns[n] ? (this.fns[n] = t, e) : !1;
	}
	use(e) {
		return this.fns.push(e), this.fns.length - 1;
	}
}, ie = () => ({
	error: new b(),
	request: new b(),
	response: new b()
}), ae = g({
	allowReserved: !1,
	array: {
		explode: !0,
		style: "form"
	},
	object: {
		explode: !0,
		style: "deepObject"
	}
}), oe = { "Content-Type": "application/json" }, x = (e = {}) => ({
	...r,
	headers: oe,
	parseAs: "auto",
	querySerializer: ae,
	...e
}), S = ((e = {}) => {
	let t = v(x(), e), n = () => ({ ...t }), r = (e) => (t = v(t, e), n()), a = ie(), o = async (e) => {
		let n = {
			...t,
			...e,
			fetch: e.fetch ?? t.fetch ?? globalThis.fetch,
			headers: y(t.headers, e.headers),
			serializedBody: void 0
		};
		return n.security && await ne({
			...n,
			security: n.security
		}), n.requestValidator && await n.requestValidator(n), n.body !== void 0 && n.bodySerializer && (n.serializedBody = n.bodySerializer(n.body)), (n.body === void 0 || n.serializedBody === "") && n.headers.delete("Content-Type"), {
			opts: n,
			url: _(n)
		};
	}, s = async (e) => {
		let { opts: t, url: n } = await o(e), r = {
			redirect: "follow",
			...t,
			body: m(t)
		}, i = new Request(n, r);
		for (let e of a.request.fns) e && (i = await e(i, t));
		let s = t.fetch, c;
		try {
			c = await s(i);
		} catch (e) {
			let n = e;
			for (let r of a.error.fns) r && (n = await r(e, void 0, i, t));
			if (n ||= {}, t.throwOnError) throw n;
			return t.responseStyle === "data" ? void 0 : {
				error: n,
				request: i,
				response: void 0
			};
		}
		for (let e of a.response.fns) e && (c = await e(c, i, t));
		let l = {
			request: i,
			response: c
		};
		if (c.ok) {
			let e = (t.parseAs === "auto" ? ee(c.headers.get("Content-Type")) : t.parseAs) ?? "json";
			if (c.status === 204 || c.headers.get("Content-Length") === "0") {
				let n;
				switch (e) {
					case "arrayBuffer":
					case "blob":
					case "text":
						n = await c[e]();
						break;
					case "formData":
						n = new FormData();
						break;
					case "stream":
						n = c.body;
						break;
					default:
						n = {};
						break;
				}
				return t.responseStyle === "data" ? n : {
					data: n,
					...l
				};
			}
			let n;
			switch (e) {
				case "arrayBuffer":
				case "blob":
				case "formData":
				case "text":
					n = await c[e]();
					break;
				case "json": {
					let e = await c.text();
					n = e ? JSON.parse(e) : {};
					break;
				}
				case "stream": return t.responseStyle === "data" ? c.body : {
					data: c.body,
					...l
				};
			}
			return e === "json" && (t.responseValidator && await t.responseValidator(n), t.responseTransformer && (n = await t.responseTransformer(n))), t.responseStyle === "data" ? n : {
				data: n,
				...l
			};
		}
		let u = await c.text(), d;
		try {
			d = JSON.parse(u);
		} catch {}
		let f = d ?? u, p = f;
		for (let e of a.error.fns) e && (p = await e(f, c, i, t));
		if (p ||= {}, t.throwOnError) throw p;
		return t.responseStyle === "data" ? void 0 : {
			error: p,
			...l
		};
	}, c = (e) => (t) => s({
		...t,
		method: e
	}), l = (e) => async (t) => {
		let { opts: n, url: r } = await o(t);
		return i({
			...n,
			body: n.body,
			headers: n.headers,
			method: e,
			onRequest: async (e, t) => {
				let r = new Request(e, t);
				for (let e of a.request.fns) e && (r = await e(r, n));
				return r;
			},
			serializedBody: m(n),
			url: r
		});
	};
	return {
		buildUrl: (e) => _({
			...t,
			...e
		}),
		connect: c("CONNECT"),
		delete: c("DELETE"),
		get: c("GET"),
		getConfig: n,
		head: c("HEAD"),
		interceptors: a,
		options: c("OPTIONS"),
		patch: c("PATCH"),
		post: c("POST"),
		put: c("PUT"),
		request: s,
		setConfig: r,
		sse: {
			connect: l("CONNECT"),
			delete: l("DELETE"),
			get: l("GET"),
			head: l("HEAD"),
			options: l("OPTIONS"),
			patch: l("PATCH"),
			post: l("POST"),
			put: l("PUT"),
			trace: l("TRACE")
		},
		trace: c("TRACE")
	};
})(x({
	baseUrl: "https://rule.api.myparcel.nl",
	throwOnError: !0
})), C = n.string().length(2).regex(/[A-Z]{2}/).register(n.globalRegistry, { description: "ISO 3166-1 alpha-2 country code." }), w = n.enum(["EU", "NON_EU"]).register(n.globalRegistry, { description: "A geographic area code that represents a specific list of countries." }), T = n.object({
	notifyOnDelivery: n.record(n.string(), n.never()).register(n.globalRegistry, { description: "Notify sender upon package delivery." }).optional(),
	preferredDate: n.object({ date: n.iso.date().register(n.globalRegistry, { description: "Recipient specified preferred delivery date." }) }).register(n.globalRegistry, { description: "This option allows you to set a preferred date for delivery, so a drop off date can be calculated." }).optional()
}).register(n.globalRegistry, { description: "Options regarding delivery timing and notifications." }), E = n.object({
	additionalInsurance: n.record(n.string(), n.never()).register(n.globalRegistry, { description: "Provides enhanced insurance coverage beyond the standard amount." }).optional(),
	deliverAtPostalPoint: n.record(n.string(), n.never()).register(n.globalRegistry, { description: "Indicates that the parcel will be delivered to a designated postal service point rather than the recipient's address, requiring the recipient to collect it from that location." }).optional(),
	freshFood: n.record(n.string(), n.never()).register(n.globalRegistry, { description: "Designates the shipment as containing perishable, non-frozen food items, ensuring appropriate handling procedures are applied to maintain freshness and prevent spoilage during transit." }).optional(),
	frozen: n.record(n.string(), n.never()).register(n.globalRegistry, { description: "Specifies that the shipment contains items that must remain frozen, necessitating strict, continuous temperature-controlled environments throughout the transit process to prevent thawing." }).optional(),
	hideSender: n.record(n.string(), n.never()).register(n.globalRegistry, { description: "Omits the sender's information from the shipping label, maintaining sender anonymity in the delivery process." }).optional(),
	insurance: n.object({ amount: n.object({
		currency: n.string().length(3).register(n.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
		micros: n.int().gte(0).lte(9007199254740991).register(n.globalRegistry, { description: "The amount of money in integer micros." })
	}).register(n.globalRegistry, { description: "The amount to insure." }) }).register(n.globalRegistry, { description: "Provides standard insurance coverage up to the specified monetary amount." }).optional(),
	noTracking: n.record(n.string(), n.never()).register(n.globalRegistry, { description: "Disables all tracking and tracing capabilities for the shipment." }).optional(),
	oversizedPackage: n.record(n.string(), n.never()).register(n.globalRegistry, { description: "Designates the shipment as exceeding standard size limitations, requiring special handling procedures and potentially incurring additional fees." }).optional(),
	printReturnLabelAtDropOff: n.record(n.string(), n.never()).register(n.globalRegistry, { description: "Provides the recipient with a digital identifier that can be presented at a drop-off location to print the return label on-site. This option is only applicable for inbound shipments." }).optional(),
	priorityDelivery: n.record(n.string(), n.never()).register(n.globalRegistry, { description: "Designates the shipment for expedited processing and transport through the delivery network, often resulting in a faster transit time compared to standard services." }).optional(),
	recipientOnlyDelivery: n.record(n.string(), n.never()).register(n.globalRegistry, { description: "Restricts delivery exclusively to the named recipient, requiring verification of recipient identity and prohibiting delivery to anyone else at the same address." }).optional(),
	requiresAgeVerification: n.record(n.string(), n.never()).register(n.globalRegistry, { description: "Requires the recipient to provide valid identification to verify they meet the minimum age requirement before the package can be released, typically used for age-restricted items." }).optional(),
	requiresCashOnDelivery: n.record(n.string(), n.never()).register(n.globalRegistry, { description: "Mandates that the carrier collect the full order amount in cash from the recipient upon delivery, ensuring payment is secured before the goods are handed over." }).optional(),
	requiresReceiptCode: n.record(n.string(), n.never()).register(n.globalRegistry, { description: "Requires the recipient to provide a specific verification code at the time of delivery, adding an extra layer of security and confirmation for sensitive shipments." }).optional(),
	requiresSignature: n.record(n.string(), n.never()).register(n.globalRegistry, { description: "Mandates that the recipient or authorized representative must provide a signature upon delivery, creating proof of receipt and transfer of responsibility." }).optional(),
	returnContributionFee: n.object({ amount: n.object({
		currency: n.string().length(3).register(n.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
		micros: n.int().gte(0).lte(9007199254740991).register(n.globalRegistry, { description: "The amount of money in integer micros." })
	}).register(n.globalRegistry, { description: "The amount of the contribution." }) }).register(n.globalRegistry, { description: "Specifies that the recipient must pay the designated contribution amount toward the cost of returning the item. This option is only applicable for inbound shipments." }).optional(),
	returnOnFirstFailedDelivery: n.record(n.string(), n.never()).register(n.globalRegistry, { description: "Instructs the carrier to return the package to the sender immediately after the first unsuccessful delivery attempt, bypassing the standard redelivery procedures or holding period." }).optional(),
	sameDayDelivery: n.record(n.string(), n.never()).register(n.globalRegistry, { description: "Expedited delivery within the same calendar day that the shipping label is created." }).optional(),
	saturdayDelivery: n.record(n.string(), n.never()).register(n.globalRegistry, { description: "Enables delivery on Saturday, which is typically outside standard delivery days, ensuring the package arrives before the start of the following work week." }).optional(),
	scheduledCollection: n.record(n.string(), n.never()).register(n.globalRegistry, { description: "Arranges for the carrier to pick up the package from the sender's location, eliminating the need for the sender to drop off the package." }).optional(),
	customLabelText: n.object({ text: n.string().min(1).max(45).register(n.globalRegistry, { description: "Allows adding personalized text to be printed on the shipping label, which can include special handling instructions or reference information." }) }).register(n.globalRegistry, { description: "Defines a custom text to be printed on the shipping label." }).optional()
}).register(n.globalRegistry, { description: "The complete set of shipment options." }), D = n.object({
	carrier: n.enum([
		"BPOST",
		"BRT",
		"CHEAP_CARGO",
		"DHL_EUROPLUS",
		"DHL_FOR_YOU",
		"DHL_PARCEL_CONNECT",
		"DPD",
		"GLS",
		"INPOST",
		"POSTNL",
		"POSTE_ITALIANE",
		"TRUNKRS",
		"UPS_EXPRESS_SAVER",
		"UPS_STANDARD",
		"VIA_TIM"
	]).register(n.globalRegistry, { description: "The carrier to select to ship a package with." }).optional(),
	customContractId: n.string().min(1).max(50).register(n.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
	delivery: n.object({
		options: T.optional(),
		type: n.enum([
			"EARLY_MORNING_DELIVERY",
			"EVENING_DELIVERY",
			"EXPRESS_DELIVERY",
			"MORNING_DELIVERY",
			"PICKUP_EXPRESS_DELIVERY",
			"PICKUP_DELIVERY",
			"SAME_DAY_DELIVERY",
			"STANDARD_DELIVERY"
		]).register(n.globalRegistry, { description: "The delivery type of the shipment." }).optional()
	}).register(n.globalRegistry, { description: "The delivery details of the shipment." }).optional(),
	direction: n.enum(["OUTBOUND", "INBOUND"]).register(n.globalRegistry, { description: "The direction of the shipment. OUTBOUND is from sender to recipient, INBOUND is from recipient to sender." }).optional(),
	numberOfLabels: n.int().gte(1).lte(20),
	options: E.optional(),
	packageType: n.enum([
		"DIGITAL_STAMP",
		"ENVELOPE",
		"MAILBOX",
		"PACKAGE",
		"PALLET",
		"SMALL_PACKAGE",
		"UNFRANKED"
	]).register(n.globalRegistry, { description: "The type of the package." }).optional()
}).register(n.globalRegistry, { description: "An action that applies specific shipping configurations to the order." }), O = n.object({ setShippingPreferences: n.object({
	applicationStrategy: n.enum(["PRESERVE", "REPLACE"]).register(n.globalRegistry, { description: "The strategy to apply the action. 'PRESERVE' keeps shipping preferences if they already exist; 'REPLACE' replaces all existing shipping preferences with the new ones." }),
	preferences: D
}).optional() }).register(n.globalRegistry, { description: "A container for the set of actions to execute. At least one action must be provided, and each action type can only be used once." }), k = n.union([n.object({ countryCode: C }), n.object({ geoAreaCode: w })]), A = n.string().min(4).max(500).register(n.globalRegistry, { description: "An expression that evaluates to true or false. The expression can contain the following fields: price, countryCode, productIds, geoAreaCode, salesChannelId, weight, and the following functions: all(), any(), evaluatedAtDayOfWeek() and evaluatedAtTimeOfDay(). See OrderExpressionProperties and OrderExpressionFunctions for more details." }), j = n.object({
	on: n.enum(["ORDER_IMPORTED"]).register(n.globalRegistry, { description: "The event that triggers the rule evaluation." }),
	rules: n.array(n.object({
		actions: O,
		condition: A,
		name: n.string().min(2).max(50).register(n.globalRegistry, { description: "A human-readable name for the rule." }),
		status: n.enum(["ACTIVE", "INACTIVE"]),
		description: n.string().min(1).max(250).register(n.globalRegistry, { description: "A description for what the rule does and its purpose." }).optional()
	})).min(1).max(1e3).register(n.globalRegistry, { description: "A prioritized list of action rules to evaluate. The rules are processed in order, and only the first matching rule will be applied." }),
	condition: k
}).register(n.globalRegistry, { description: "A prioritized list of rules for an event in a specific region." }), M = n.object({
	on: n.enum(["ORDER_IMPORTED"]).register(n.globalRegistry, { description: "The event that triggers the rule evaluation." }),
	rules: n.array(n.object({
		actions: O,
		condition: A,
		name: n.string().min(2).max(50).register(n.globalRegistry, { description: "A human-readable name for the rule." }),
		status: n.enum(["ACTIVE", "INACTIVE"]),
		description: n.string().min(1).max(250).register(n.globalRegistry, { description: "A description for what the rule does and its purpose." }).optional(),
		id: n.uuid().register(n.globalRegistry, { description: "The unique identifier of the rule." }).optional()
	})).min(1).max(1e3).register(n.globalRegistry, { description: "A prioritized list of action rules to evaluate. The rules are processed in order, and only the first matching rule will be applied." }),
	condition: k
}).register(n.globalRegistry, { description: "A prioritized list of rules for an event in a specific region." }), N = n.object({ results: n.array(n.object({
	id: n.uuid().register(n.globalRegistry, { description: "The unique identifier of the rule group." }),
	createdAt: n.union([n.string(), n.iso.datetime().register(n.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	on: n.enum(["ORDER_IMPORTED"]).register(n.globalRegistry, { description: "The event that triggers the rule evaluation." }),
	rules: n.array(n.object({
		id: n.uuid().register(n.globalRegistry, { description: "The unique identifier of the rule." }),
		actions: O,
		condition: A,
		name: n.string().min(2).max(50).register(n.globalRegistry, { description: "A human-readable name for the rule." }),
		status: n.enum(["ACTIVE", "INACTIVE"]),
		description: n.string().min(1).max(250).register(n.globalRegistry, { description: "A description for what the rule does and its purpose." }).optional()
	})).min(1).max(1e3).register(n.globalRegistry, { description: "A prioritized list of action rules to evaluate. The rules are processed in order, and only the first matching rule will be applied." }),
	condition: k,
	updatedAt: n.union([n.string(), n.iso.datetime().register(n.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]).optional()
}).register(n.globalRegistry, { description: "A prioritized list of rules for an event in a specific region." })).min(0).max(250).register(n.globalRegistry, { description: "The list of order rule groups." }) }), P = n.object({
	id: n.uuid().register(n.globalRegistry, { description: "The unique identifier of the rule group." }),
	createdAt: n.union([n.string(), n.iso.datetime().register(n.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	on: n.enum(["ORDER_IMPORTED"]).register(n.globalRegistry, { description: "The event that triggers the rule evaluation." }),
	rules: n.array(n.object({
		id: n.uuid().register(n.globalRegistry, { description: "The unique identifier of the rule." }),
		actions: O,
		condition: A,
		name: n.string().min(2).max(50).register(n.globalRegistry, { description: "A human-readable name for the rule." }),
		status: n.enum(["ACTIVE", "INACTIVE"]),
		description: n.string().min(1).max(250).register(n.globalRegistry, { description: "A description for what the rule does and its purpose." }).optional()
	})).min(1).max(1e3).register(n.globalRegistry, { description: "A prioritized list of action rules to evaluate. The rules are processed in order, and only the first matching rule will be applied." }),
	condition: k
}).register(n.globalRegistry, { description: "A prioritized list of rules for an event in a specific region." }), F = n.object({
	id: n.uuid().register(n.globalRegistry, { description: "The unique identifier of the rule group." }),
	createdAt: n.union([n.string(), n.iso.datetime().register(n.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	on: n.enum(["ORDER_IMPORTED"]).register(n.globalRegistry, { description: "The event that triggers the rule evaluation." }),
	rules: n.array(n.object({
		id: n.uuid().register(n.globalRegistry, { description: "The unique identifier of the rule." }),
		actions: O,
		condition: A,
		name: n.string().min(2).max(50).register(n.globalRegistry, { description: "A human-readable name for the rule." }),
		status: n.enum(["ACTIVE", "INACTIVE"]),
		description: n.string().min(1).max(250).register(n.globalRegistry, { description: "A description for what the rule does and its purpose." }).optional()
	})).min(1).max(1e3).register(n.globalRegistry, { description: "A prioritized list of action rules to evaluate. The rules are processed in order, and only the first matching rule will be applied." }),
	condition: k,
	updatedAt: n.union([n.string(), n.iso.datetime().register(n.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })])
}).register(n.globalRegistry, { description: "A prioritized list of rules for an event in a specific region." }), se = n.object({
	price: n.number().register(n.globalRegistry, { description: "The total price of the order." }),
	countryCode: C.optional(),
	productIds: n.array(n.uuid().register(n.globalRegistry, { description: "The unique identifier of the product." })).optional().default([]),
	geoAreaCode: w.optional(),
	salesChannelId: n.string().min(1).max(50).register(n.globalRegistry, { description: "The unique identifier of the sales channel." }).optional(),
	weight: n.int().gte(0).register(n.globalRegistry, { description: "The weight of the order in grams." }).optional()
}), ce = n.union([
	n.object({ "all(<sequence>, <item>, <condition>)": n.object({
		params: n.object({
			sequence: n.unknown().register(n.globalRegistry, { description: "The sequence to be evaluated." }).optional(),
			item: n.unknown().register(n.globalRegistry, { description: "Refers to the elements in the sequence." }).optional(),
			condition: n.unknown().register(n.globalRegistry, { description: "The condition to apply to each element." }).optional()
		}),
		example: n.unknown().optional()
	}).register(n.globalRegistry, { description: "Determine whether all elements of a sequence satisfy a condition." }) }),
	n.object({ "any(<sequence>, <item>, <condition>)": n.object({
		params: n.object({
			sequence: n.unknown().register(n.globalRegistry, { description: "The sequence to be evaluated." }).optional(),
			item: n.unknown().register(n.globalRegistry, { description: "Refers to the elements in the sequence." }).optional(),
			condition: n.unknown().register(n.globalRegistry, { description: "The condition to apply to each element." }).optional()
		}),
		example: n.unknown().optional()
	}).register(n.globalRegistry, { description: "Determine whether any elements of a sequence satisfy a condition." }) }),
	n.object({ "evaluatedAtDayOfWeek(<daysOfWeek>)": n.object({
		params: n.object({ daysOfWeek: n.array(n.enum([
			"MONDAY",
			"TUESDAY",
			"WEDNESDAY",
			"THURSDAY",
			"FRIDAY",
			"SATURDAY",
			"SUNDAY"
		]).register(n.globalRegistry, { description: "Day of week." })).min(1).max(7).register(n.globalRegistry, { description: "List of week days." }) }),
		example: n.unknown().optional()
	}).register(n.globalRegistry, { description: "Evaluates to true if the rule evaluation day of week is one of the specified days of the week." }) }),
	n.object({ "evaluatedAtTimeOfDay(<operator>, <time>, <timezone>)": n.object({
		params: n.object({
			operator: n.enum([
				"<",
				"<=",
				">",
				">="
			]).register(n.globalRegistry, { description: "The comparison operator." }),
			time: n.string().regex(/^([01]\d|2[0-3]):[0-5]\d:[0-5]\d$/).register(n.globalRegistry, { description: "A time string formatted as HH:mm:ss." }),
			timezone: n.string().register(n.globalRegistry, { description: "The timezone of the specified time." })
		}),
		example: n.unknown().optional()
	}).register(n.globalRegistry, { description: "Compare the rule evaluation time of day with a specified time within a specified timezone." }) })
]), I = n.uuid().register(n.globalRegistry, { description: "The unique identifier of the rule group." }), L = n.string().min(1).max(50).register(n.globalRegistry, { description: "The unique identifier of the shop." }), le = I, ue = L, R = n.object({
	body: n.never().optional(),
	path: n.object({ shopId: L }),
	query: n.never().optional()
}), de = N, z = n.object({
	body: j.optional(),
	path: n.object({ shopId: L }),
	query: n.never().optional()
}), fe = P, B = n.object({
	body: n.never().optional(),
	path: n.object({
		ruleGroupId: I,
		shopId: L
	}),
	query: n.never().optional()
}), pe = n.void().register(n.globalRegistry, { description: "The order rule group is successfully deleted." }), V = n.object({
	body: M.optional(),
	path: n.object({
		ruleGroupId: I,
		shopId: L
	}),
	query: n.never().optional()
}), me = F, H = n.string().register(n.globalRegistry, { description: "ISO 3166-1 alpha-2 country code." }), U = n.union([n.enum(["EU", "NON_EU"]), n.string()]).register(n.globalRegistry, { description: "A geographic area code that represents a specific list of countries." }), he = n.object({
	notifyOnDelivery: n.record(n.string(), n.never()).register(n.globalRegistry, { description: "Notify sender upon package delivery." }).optional(),
	preferredDate: n.object({ date: n.iso.date().register(n.globalRegistry, { description: "Recipient specified preferred delivery date." }) }).register(n.globalRegistry, { description: "This option allows you to set a preferred date for delivery, so a drop off date can be calculated." }).optional()
}).register(n.globalRegistry, { description: "Options regarding delivery timing and notifications." }), ge = n.object({
	additionalInsurance: n.record(n.string(), n.never()).register(n.globalRegistry, { description: "Provides enhanced insurance coverage beyond the standard amount." }).optional(),
	deliverAtPostalPoint: n.record(n.string(), n.never()).register(n.globalRegistry, { description: "Indicates that the parcel will be delivered to a designated postal service point rather than the recipient's address, requiring the recipient to collect it from that location." }).optional(),
	freshFood: n.record(n.string(), n.never()).register(n.globalRegistry, { description: "Designates the shipment as containing perishable, non-frozen food items, ensuring appropriate handling procedures are applied to maintain freshness and prevent spoilage during transit." }).optional(),
	frozen: n.record(n.string(), n.never()).register(n.globalRegistry, { description: "Specifies that the shipment contains items that must remain frozen, necessitating strict, continuous temperature-controlled environments throughout the transit process to prevent thawing." }).optional(),
	hideSender: n.record(n.string(), n.never()).register(n.globalRegistry, { description: "Omits the sender's information from the shipping label, maintaining sender anonymity in the delivery process." }).optional(),
	insurance: n.object({ amount: n.object({
		currency: n.string().register(n.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
		micros: n.int().gte(0).lte(9007199254740991).register(n.globalRegistry, { description: "The amount of money in integer micros." })
	}).register(n.globalRegistry, { description: "The amount to insure." }) }).register(n.globalRegistry, { description: "Provides standard insurance coverage up to the specified monetary amount." }).optional(),
	noTracking: n.record(n.string(), n.never()).register(n.globalRegistry, { description: "Disables all tracking and tracing capabilities for the shipment." }).optional(),
	oversizedPackage: n.record(n.string(), n.never()).register(n.globalRegistry, { description: "Designates the shipment as exceeding standard size limitations, requiring special handling procedures and potentially incurring additional fees." }).optional(),
	printReturnLabelAtDropOff: n.record(n.string(), n.never()).register(n.globalRegistry, { description: "Provides the recipient with a digital identifier that can be presented at a drop-off location to print the return label on-site. This option is only applicable for inbound shipments." }).optional(),
	priorityDelivery: n.record(n.string(), n.never()).register(n.globalRegistry, { description: "Designates the shipment for expedited processing and transport through the delivery network, often resulting in a faster transit time compared to standard services." }).optional(),
	recipientOnlyDelivery: n.record(n.string(), n.never()).register(n.globalRegistry, { description: "Restricts delivery exclusively to the named recipient, requiring verification of recipient identity and prohibiting delivery to anyone else at the same address." }).optional(),
	requiresAgeVerification: n.record(n.string(), n.never()).register(n.globalRegistry, { description: "Requires the recipient to provide valid identification to verify they meet the minimum age requirement before the package can be released, typically used for age-restricted items." }).optional(),
	requiresCashOnDelivery: n.record(n.string(), n.never()).register(n.globalRegistry, { description: "Mandates that the carrier collect the full order amount in cash from the recipient upon delivery, ensuring payment is secured before the goods are handed over." }).optional(),
	requiresReceiptCode: n.record(n.string(), n.never()).register(n.globalRegistry, { description: "Requires the recipient to provide a specific verification code at the time of delivery, adding an extra layer of security and confirmation for sensitive shipments." }).optional(),
	requiresSignature: n.record(n.string(), n.never()).register(n.globalRegistry, { description: "Mandates that the recipient or authorized representative must provide a signature upon delivery, creating proof of receipt and transfer of responsibility." }).optional(),
	returnContributionFee: n.object({ amount: n.object({
		currency: n.string().register(n.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
		micros: n.int().gte(0).lte(9007199254740991).register(n.globalRegistry, { description: "The amount of money in integer micros." })
	}).register(n.globalRegistry, { description: "The amount of the contribution." }) }).register(n.globalRegistry, { description: "Specifies that the recipient must pay the designated contribution amount toward the cost of returning the item. This option is only applicable for inbound shipments." }).optional(),
	returnOnFirstFailedDelivery: n.record(n.string(), n.never()).register(n.globalRegistry, { description: "Instructs the carrier to return the package to the sender immediately after the first unsuccessful delivery attempt, bypassing the standard redelivery procedures or holding period." }).optional(),
	sameDayDelivery: n.record(n.string(), n.never()).register(n.globalRegistry, { description: "Expedited delivery within the same calendar day that the shipping label is created." }).optional(),
	saturdayDelivery: n.record(n.string(), n.never()).register(n.globalRegistry, { description: "Enables delivery on Saturday, which is typically outside standard delivery days, ensuring the package arrives before the start of the following work week." }).optional(),
	scheduledCollection: n.record(n.string(), n.never()).register(n.globalRegistry, { description: "Arranges for the carrier to pick up the package from the sender's location, eliminating the need for the sender to drop off the package." }).optional(),
	customLabelText: n.object({ text: n.string().register(n.globalRegistry, { description: "Allows adding personalized text to be printed on the shipping label, which can include special handling instructions or reference information." }) }).register(n.globalRegistry, { description: "Defines a custom text to be printed on the shipping label." }).optional()
}).register(n.globalRegistry, { description: "The complete set of shipment options." }), _e = n.object({
	carrier: n.union([n.enum([
		"BPOST",
		"BRT",
		"CHEAP_CARGO",
		"DHL_EUROPLUS",
		"DHL_FOR_YOU",
		"DHL_PARCEL_CONNECT",
		"DPD",
		"GLS",
		"INPOST",
		"POSTNL",
		"POSTE_ITALIANE",
		"TRUNKRS",
		"UPS_EXPRESS_SAVER",
		"UPS_STANDARD",
		"VIA_TIM"
	]), n.string()]).register(n.globalRegistry, { description: "The carrier to select to ship a package with." }).optional(),
	customContractId: n.string().register(n.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
	delivery: n.object({
		options: he.optional(),
		type: n.union([n.enum([
			"EARLY_MORNING_DELIVERY",
			"EVENING_DELIVERY",
			"EXPRESS_DELIVERY",
			"MORNING_DELIVERY",
			"PICKUP_EXPRESS_DELIVERY",
			"PICKUP_DELIVERY",
			"SAME_DAY_DELIVERY",
			"STANDARD_DELIVERY"
		]), n.string()]).register(n.globalRegistry, { description: "The delivery type of the shipment." }).optional()
	}).register(n.globalRegistry, { description: "The delivery details of the shipment." }).optional(),
	direction: n.union([n.enum(["OUTBOUND", "INBOUND"]), n.string()]).register(n.globalRegistry, { description: "The direction of the shipment. OUTBOUND is from sender to recipient, INBOUND is from recipient to sender." }).optional(),
	numberOfLabels: n.int().gte(1).lte(20),
	options: ge.optional(),
	packageType: n.union([n.enum([
		"DIGITAL_STAMP",
		"ENVELOPE",
		"MAILBOX",
		"PACKAGE",
		"PALLET",
		"SMALL_PACKAGE",
		"UNFRANKED"
	]), n.string()]).register(n.globalRegistry, { description: "The type of the package." }).optional()
}).register(n.globalRegistry, { description: "An action that applies specific shipping configurations to the order." }), W = n.object({ setShippingPreferences: n.object({
	applicationStrategy: n.union([n.enum(["PRESERVE", "REPLACE"]), n.string()]).register(n.globalRegistry, { description: "The strategy to apply the action. 'PRESERVE' keeps shipping preferences if they already exist; 'REPLACE' replaces all existing shipping preferences with the new ones." }),
	preferences: _e
}).optional() }).register(n.globalRegistry, { description: "A container for the set of actions to execute. At least one action must be provided, and each action type can only be used once." }), G = n.union([n.object({ countryCode: H }), n.object({ geoAreaCode: U })]), K = n.string().register(n.globalRegistry, { description: "An expression that evaluates to true or false. The expression can contain the following fields: price, countryCode, productIds, geoAreaCode, salesChannelId, weight, and the following functions: all(), any(), evaluatedAtDayOfWeek() and evaluatedAtTimeOfDay(). See OrderExpressionProperties and OrderExpressionFunctions for more details." }), ve = n.object({
	on: n.union([n.enum(["ORDER_IMPORTED"]), n.string()]).register(n.globalRegistry, { description: "The event that triggers the rule evaluation." }),
	rules: n.array(n.object({
		actions: W,
		condition: K,
		name: n.string().register(n.globalRegistry, { description: "A human-readable name for the rule." }),
		status: n.union([n.enum(["ACTIVE", "INACTIVE"]), n.string()]),
		description: n.string().register(n.globalRegistry, { description: "A description for what the rule does and its purpose." }).optional()
	})).register(n.globalRegistry, { description: "A prioritized list of action rules to evaluate. The rules are processed in order, and only the first matching rule will be applied." }),
	condition: G
}).register(n.globalRegistry, { description: "A prioritized list of rules for an event in a specific region." }), ye = n.object({
	on: n.union([n.enum(["ORDER_IMPORTED"]), n.string()]).register(n.globalRegistry, { description: "The event that triggers the rule evaluation." }),
	rules: n.array(n.object({
		actions: W,
		condition: K,
		name: n.string().register(n.globalRegistry, { description: "A human-readable name for the rule." }),
		status: n.union([n.enum(["ACTIVE", "INACTIVE"]), n.string()]),
		description: n.string().register(n.globalRegistry, { description: "A description for what the rule does and its purpose." }).optional(),
		id: n.uuid().register(n.globalRegistry, { description: "The unique identifier of the rule." }).optional()
	})).register(n.globalRegistry, { description: "A prioritized list of action rules to evaluate. The rules are processed in order, and only the first matching rule will be applied." }),
	condition: G
}).register(n.globalRegistry, { description: "A prioritized list of rules for an event in a specific region." }), be = n.object({ results: n.array(n.object({
	id: n.uuid().register(n.globalRegistry, { description: "The unique identifier of the rule group." }),
	createdAt: n.union([n.string(), n.iso.datetime().register(n.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	on: n.union([n.enum(["ORDER_IMPORTED"]), n.string()]).register(n.globalRegistry, { description: "The event that triggers the rule evaluation." }),
	rules: n.array(n.object({
		id: n.uuid().register(n.globalRegistry, { description: "The unique identifier of the rule." }),
		actions: W,
		condition: K,
		name: n.string().register(n.globalRegistry, { description: "A human-readable name for the rule." }),
		status: n.union([n.enum(["ACTIVE", "INACTIVE"]), n.string()]),
		description: n.string().register(n.globalRegistry, { description: "A description for what the rule does and its purpose." }).optional()
	})).min(1).max(1e3).register(n.globalRegistry, { description: "A prioritized list of action rules to evaluate. The rules are processed in order, and only the first matching rule will be applied." }),
	condition: G,
	updatedAt: n.union([n.string(), n.iso.datetime().register(n.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]).optional()
}).register(n.globalRegistry, { description: "A prioritized list of rules for an event in a specific region." })).register(n.globalRegistry, { description: "The list of order rule groups." }) }), xe = n.object({
	id: n.uuid().register(n.globalRegistry, { description: "The unique identifier of the rule group." }),
	createdAt: n.union([n.string(), n.iso.datetime().register(n.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	on: n.union([n.enum(["ORDER_IMPORTED"]), n.string()]).register(n.globalRegistry, { description: "The event that triggers the rule evaluation." }),
	rules: n.array(n.object({
		id: n.uuid().register(n.globalRegistry, { description: "The unique identifier of the rule." }),
		actions: W,
		condition: K,
		name: n.string().register(n.globalRegistry, { description: "A human-readable name for the rule." }),
		status: n.union([n.enum(["ACTIVE", "INACTIVE"]), n.string()]),
		description: n.string().register(n.globalRegistry, { description: "A description for what the rule does and its purpose." }).optional()
	})).register(n.globalRegistry, { description: "A prioritized list of action rules to evaluate. The rules are processed in order, and only the first matching rule will be applied." }),
	condition: G
}).register(n.globalRegistry, { description: "A prioritized list of rules for an event in a specific region." }), Se = n.object({
	id: n.uuid().register(n.globalRegistry, { description: "The unique identifier of the rule group." }),
	createdAt: n.union([n.string(), n.iso.datetime().register(n.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	on: n.union([n.enum(["ORDER_IMPORTED"]), n.string()]).register(n.globalRegistry, { description: "The event that triggers the rule evaluation." }),
	rules: n.array(n.object({
		id: n.uuid().register(n.globalRegistry, { description: "The unique identifier of the rule." }),
		actions: W,
		condition: K,
		name: n.string().register(n.globalRegistry, { description: "A human-readable name for the rule." }),
		status: n.union([n.enum(["ACTIVE", "INACTIVE"]), n.string()]),
		description: n.string().register(n.globalRegistry, { description: "A description for what the rule does and its purpose." }).optional()
	})).register(n.globalRegistry, { description: "A prioritized list of action rules to evaluate. The rules are processed in order, and only the first matching rule will be applied." }),
	condition: G,
	updatedAt: n.union([n.string(), n.iso.datetime().register(n.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })])
}).register(n.globalRegistry, { description: "A prioritized list of rules for an event in a specific region." });
n.object({
	price: n.number().register(n.globalRegistry, { description: "The total price of the order." }),
	countryCode: H.optional(),
	productIds: n.array(n.uuid().register(n.globalRegistry, { description: "The unique identifier of the product." })).optional().default([]),
	geoAreaCode: U.optional(),
	salesChannelId: n.string().register(n.globalRegistry, { description: "The unique identifier of the sales channel." }).optional(),
	weight: n.int().gte(0).register(n.globalRegistry, { description: "The weight of the order in grams." }).optional()
}), n.union([
	n.object({ "all(<sequence>, <item>, <condition>)": n.object({
		params: n.object({
			sequence: n.unknown().register(n.globalRegistry, { description: "The sequence to be evaluated." }).optional(),
			item: n.unknown().register(n.globalRegistry, { description: "Refers to the elements in the sequence." }).optional(),
			condition: n.unknown().register(n.globalRegistry, { description: "The condition to apply to each element." }).optional()
		}),
		example: n.unknown().optional()
	}).register(n.globalRegistry, { description: "Determine whether all elements of a sequence satisfy a condition." }) }),
	n.object({ "any(<sequence>, <item>, <condition>)": n.object({
		params: n.object({
			sequence: n.unknown().register(n.globalRegistry, { description: "The sequence to be evaluated." }).optional(),
			item: n.unknown().register(n.globalRegistry, { description: "Refers to the elements in the sequence." }).optional(),
			condition: n.unknown().register(n.globalRegistry, { description: "The condition to apply to each element." }).optional()
		}),
		example: n.unknown().optional()
	}).register(n.globalRegistry, { description: "Determine whether any elements of a sequence satisfy a condition." }) }),
	n.object({ "evaluatedAtDayOfWeek(<daysOfWeek>)": n.object({
		params: n.object({ daysOfWeek: n.array(n.union([n.enum([
			"MONDAY",
			"TUESDAY",
			"WEDNESDAY",
			"THURSDAY",
			"FRIDAY",
			"SATURDAY",
			"SUNDAY"
		]), n.string()]).register(n.globalRegistry, { description: "Day of week." })).register(n.globalRegistry, { description: "List of week days." }) }),
		example: n.unknown().optional()
	}).register(n.globalRegistry, { description: "Evaluates to true if the rule evaluation day of week is one of the specified days of the week." }) }),
	n.object({ "evaluatedAtTimeOfDay(<operator>, <time>, <timezone>)": n.object({
		params: n.object({
			operator: n.union([n.enum([
				"<",
				"<=",
				">",
				">="
			]), n.string()]).register(n.globalRegistry, { description: "The comparison operator." }),
			time: n.string().register(n.globalRegistry, { description: "A time string formatted as HH:mm:ss." }),
			timezone: n.string().register(n.globalRegistry, { description: "The timezone of the specified time." })
		}),
		example: n.unknown().optional()
	}).register(n.globalRegistry, { description: "Compare the rule evaluation time of day with a specified time within a specified timezone." }) })
]);
var q = n.uuid().register(n.globalRegistry, { description: "The unique identifier of the rule group." }), J = n.string().register(n.globalRegistry, { description: "The unique identifier of the shop." });
n.object({
	body: n.never().optional(),
	path: n.object({ shopId: J }),
	query: n.never().optional()
});
var Ce = be;
n.object({
	body: ve.optional(),
	path: n.object({ shopId: J }),
	query: n.never().optional()
});
var we = xe;
n.object({
	body: n.never().optional(),
	path: n.object({
		ruleGroupId: q,
		shopId: J
	}),
	query: n.never().optional()
});
var Te = n.void().register(n.globalRegistry, { description: "The order rule group is successfully deleted." });
n.object({
	body: ye.optional(),
	path: n.object({
		ruleGroupId: q,
		shopId: J
	}),
	query: n.never().optional()
});
var Ee = Se, Y = (e) => (e.client ?? S).get({
	requestValidator: async (e) => await R.parseAsync(e),
	responseValidator: async (e) => await Ce.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/shops/{shopId}/order-rules",
	...e
}), X = (e) => (e.client ?? S).post({
	requestValidator: async (e) => await z.parseAsync(e),
	responseValidator: async (e) => await we.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/shops/{shopId}/order-rules",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Z = (e) => (e.client ?? S).delete({
	requestValidator: async (e) => await B.parseAsync(e),
	responseValidator: async (e) => await Te.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/shops/{shopId}/order-rules/{ruleGroupId}",
	...e
}), Q = (e) => (e.client ?? S).put({
	requestValidator: async (e) => await V.parseAsync(e),
	responseValidator: async (e) => await Ee.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/shops/{shopId}/order-rules/{ruleGroupId}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), De = () => S.getConfig().auth, Oe = (n = { token: void 0 }) => {
	if (!n.token) throw Error("Token is required");
	let r = {
		baseUrl: e,
		auth: n.token,
		querySerializer: g()
	};
	return n.environment && n.environment === "acceptance" && (r.baseUrl = t), n.locale && (r.headers = {
		...r.headers,
		"Accept-Language": n.locale
	}), S.setConfig(r), n.token;
}, ke = async (e, t) => (await Y({
	path: e,
	signal: t.signal
})).data, Ae = async ({ shopId: e, body: t }) => (await X({
	path: { shopId: e },
	body: t
})).data, $ = async ({ shopId: e, ruleGroupId: t, body: n }) => (await Q({
	path: {
		shopId: e,
		ruleGroupId: t
	},
	body: n
})).data, je = (e) => {
	S.setConfig({ headers: {
		...S.getConfig().headers,
		"Accept-Language": e
	} });
}, Me = async ({ shopId: e, ruleGroupId: t }) => Z({ path: {
	shopId: e,
	ruleGroupId: t
} }), Ne = () => ({
	deleteOrderRuleGroup: Me,
	getOrderRules: ke,
	getToken: De,
	initClient: Oe,
	postOrderRuleGroup: Ae,
	putOrderRuleGroup: $,
	setAcceptLanguageHeader: je
});
//#endregion
export { D as A, M as C, I as D, me as E, ue as M, S as N, le as O, fe as S, V as T, se as _, Q as a, P as b, pe as c, N as d, R as f, ce as g, A as h, X as i, L as j, E as k, T as l, O as m, Z as n, C as o, de as p, Y as r, B as s, Ne as t, w as u, k as v, F as w, z as x, j as y };
